<template>
    <q-card v-bind="attrs">
        <q-card-section class="q-pt-none q-pl-sm" >
            <div v-if="data[spLayer]" id="fishPane">
                <div class="row justify-end q-pa-sm print-hide">About these data <q-icon name="help_outline" class="q-pl-sm pointer" size="xs"  @click="dataConsiderations = !dataConsiderations"/></div>
                <div class="row items-center q-pa-sm print-hide">
                    <div class="col-2">Group:<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs[activeGroup.value].model = !infoDialogs[activeGroup.value].model" aria-label="Fish group data help"/></div>
                    <div class="col-5 q-pa-sm">
                         <q-select class="q-mr-sm" dense outlined :options="spGroupChoices" v-model="activeGroup"></q-select>
                     </div>
                     <div class="col-1">Season:</div>
                     <div class="col-4 q-pa-sm">  
                         <q-select class="q-ml-sm" dense outlined :options="seasons" v-model="season" @update:model-value="seasonChange()"></q-select>
                     </div>
                </div>
                <div class="text-h5">{{ activeGroup.label }} | {{ season.label }}</div>
                <div class="text-h6 q-mt-md row text-uppercase" ><span class="text-bold">Diversity<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['fishDiversity'].model = !infoDialogs['fishDiversity'].model" aria-label="Fish group data help"/></span></div>
                <q-card flat class="q-pa-xs">
                    <div class="row justify-start items-center">
                        <div class="col-6 text-center items-center text-caption">
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numSpp }}</div><div class="col-9 text-left">species estimated within this area (abundance >75 percentile)</div></div>
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numGTVal }}</div><div class="col-9 text-left">species at very high abundance levels (>90 percentile)</div></div>                      
                        </div>
                        <div class="col-6 text-center items-center text-caption" v-if="(activeGroup.value == 'all' || activeGroup.value == 'demersal') && dialVals.numSpp >0" >
                            <div class="row">Relative to the {{ ecos[data['majEcoregion']] }} ecoregion: 
                                <q-btn v-if="season.value == 'ALL'" dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['fishDialAll'].model = !infoDialogs['fishDialAll'].model" aria-label="Fish dial help"/> 
                                <q-btn v-if="season.value == 'SPR'" dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['fishDialSpr'].model = !infoDialogs['fishDialSpr'].model" aria-label="Fish dial help"/>
                                <q-btn v-if="season.value == 'FALL'" dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['fishDialFal'].model = !infoDialogs['fishDialFal'].model" aria-label="Fish dial help"/>
                            </div>
                            <div class="text-center q-ml-lg dial-container"><Dial  divName="fishDial"  :dialConfig="zDialConfig" :colors="dialColors" :dialVal="dialVals.dialVal" /></div>
                            <div class="text-center">(
                                <span v-if="dialVals.dialVal >=2.5">&ge;</span>
                                <span v-if="dialVals.dialVal <=-2.5">&le;</span>
                                {{ Math.round(dialVals.dialVal *10 ) /10}} SD)
                            </div>
                            
                        </div>
                        <div class="q-pa-sm text-caption text-italic" v-if="season.value == 'ALL'">NOTE: These values are based on annual maximums</div>
                    </div>
                </q-card>
                
                <div class="text-h6 q-mt-lg text-uppercase"><span class="text-bold">Abundance<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['fishAbundance'].model = !infoDialogs['fishAbundance'].model" aria-label="Fish abundance data help"/></span></div>    
                <div class="tab-container shadow-1">
                    <q-tabs v-model="fishTabs">
                        <q-tab :label="barChartTabTitle"  @click="loadDataByID(spLayer, version), clearMap()" name="density"></q-tab>
                        <q-tab :label="decadeTabTitle" @click="loadDataByID(fishTimeLayer, version), clearMap()" name="time" ></q-tab>
                    </q-tabs>
                    <q-tab-panels dense v-model="fishTabs">
                        <q-tab-panel name="density" class="q-pa-xs">   
                            <q-card flat class="q-pl-xs">

                                <div :style="{'min-height' : '25px'}" class="q-mt-sm">
                                    <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                        <div class="col-2 text-secondary">
                                            <span class="text-bold ">DATA ON THE MAP</span>:
                                        </div>
                                        <div class="col-6">
                                            <q-select
                                                :hide-bottom-space="true"
                                                dense
                                                class="secondary-dropdown q-ma-xs q-pa-xs"
                                                :options="spChoices"
                                                map-options
                                                v-model="activeSpCode"
                                                @update:model-value="rowClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                                hint="Select a species or click below"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>

                                        <div class="col-1 justify-end items-end">
                                            <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                        </div>     
                                    </div>
                                </div>



                                <div class="row bar-header justify-center text-caption text-bold q-pr-sm">
                                        <div class="col-7 text-center">Species</div>
                                        <div class="col-3 text-right q-pl-lg">
                                            % High
                                            <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['pHigh'].model = !infoDialogs['pHigh'].model" aria-label="High threshold help"/>
                                        </div>
                                </div>
                                <div class="bar-rows-container q-pr-sm"                                 
                                    tabindex="0" 
                                    role="region" 
                                    aria-label="Scrollable bar rows"
                                >
                                    <div v-for="barCat, i in barData" 
                                        @click="rowClick(barCat[0].spID, barCat[0].sp)"
                                        class="row pointer bar-row justify-center"
                                        :class="mapStyleInfo['attr'] === barCat[0].spID ? 'highlight' : ''">
                                        <div class="col-10">
                                            <StackedBar 
                                                :data="barCat" 
                                                :divName="barName(i)" 
                                                categoryProp="category" 
                                                barName="sp" 
                                                valueProp="value" 
                                                class="q-mt-none" 
                                                :xAxisTicks="false"
                                                :categoryColors="barColors"
                                                :topMargin="0"                                       
                                            />
                                        </div>

                                        <!-- the % high + very high is repeated for each sp obj in the array, so just take the first -->
                                        <div class="col-1 text-caption">{{ barCat[0].percHighVH }}</div>
                                    </div>
                                </div>
                                
                            
                            
                            </q-card>             
                        </q-tab-panel>
                        <q-tab-panel name="time"  class="q-pa-xs">
                            <div v-if="data[fishTimeLayer]" class="time-table-container">
                                <div :style="{'min-height' : '25px'}" class="q-mt-sm">
                                    <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                        <div class="col-2 text-secondary">
                                            <span class="text-bold ">DATA ON THE MAP</span>:
                                        </div>
                                        <div class="col-6">
                                            <q-select
                                                :hide-bottom-space="true"
                                                dense
                                                class="secondary-dropdown q-ma-xs q-pa-xs"
                                                :options="spChoices"
                                                map-options
                                                v-model="activeSpCode"
                                                @update:model-value="spChange(activeSpCode.value, AllCodes[activeSpCode.value])"
                                                hint="Select a species or click below"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-3">
                                        <q-select 
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="decades" 
                                            v-model="decade"  
                                            @update:model-value="decadeChange"
                                            hint="Time period"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                        <div class="col-1 justify-end items-end">
                                            <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                        </div>     
                                    </div>
                                </div>


                                <Table 
                                    :version="version"
                                    :rows="fishOverTime" 
                                    :columns="columns"
                                    title=""
                                    :expandRows="false"
                                    :mapStyle="true"
                                    :mapStops="stops['spp_90max']"
                                    :mapClassNames="legendColorStopNames"
                                    :cellColors="tableCellColors"
                                    :labelCells="false"
                                    :mapLayer="null"
                                    :mapLegendTitles="fishTimeLegendTitles"
                                    :season="season.value"
                                    :selSp="activeSpCode ? activeSpCode : null"
                                    :selDecade="decade ? decade : null"
                                    @cellClick="tableClickEmitFunc"
                                ></Table>
                            </div>
                            <div v-else class="row justify-center">
                                <q-spinner size="lg"></q-spinner>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                </div>
                <div class="row text-center justify-center q-mt-md">
                    <div class="col-2" :style="{'background-color' : barColors['High'], 'color' :'white'}">High<br/>(>90)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Medium']}">Medium<br/>(>75)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Low']}">Low<br/>(>1)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Very Low']}">Very Low<br/>(>0)</div>
                    <div class="col-2" :style="{'background-color' : barColors['No Data']}">No Data</div>
                </div>
            </div>
            <div v-else class="row justify-center">
                <q-spinner size="lg"></q-spinner>
            </div>
            
        </q-card-section>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
    <template>
        <q-dialog v-model="dataConsiderations">
            <q-card>
            <q-card-section>
                <SpeciesDataConsiderations groupsToShow="fish" />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" @click="dataConsiderations = false" />
            </q-card-actions>
            </q-card>
        </q-dialog>
    </template>
</template>
<script setup lang="ts">
import { toRefs, ref, onMounted, onUnmounted, computed, useAttrs } from "vue";
import { QTableColumn } from 'quasar';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops, dqStops } from "../assets/ColorStops.json"
import Dial from "./Dial.vue";
import StackedBar from "./StackedBar.vue";
import Table from "./Table.vue";
import InfoDialog from "./InfoDialog.vue";
import SpeciesDataConsiderations from "./SpeciesDataConsiderations.vue";
import { FishGroups } from "../assets/FishGroups.json"
import { FishMeanSDs } from "../assets/MeanSDs.json"
import { AllCodes } from "../assets/SppCodesToNames.json"
const {  processDialData, processStackedBarData, ecos,  styleMap, setLegend, mapStyleInfo, clearMapStyle, activeLayerID, processedData, setProcessedData, setDataQuality, loadDataByID,userPolygon, getData,activeSpGroups, setActiveSpGroups } = useMapItems()
const {  arrayFindObjectByProp, logGAevent } = useHelpers();
const attrs = useAttrs();

const props = defineProps({
    data: { type: Object },
    version: {type: Number},
    ecoregion: {type: String},
})
const {  data, version, ecoregion } = toRefs(props)

const dialVals = computed(() =>{
    // the 2nd to last value is the threshold for "spp supported by this site"
    // the last value (90) is used as the threshold for defining very high abundance.  # of sp with presence >= that value in AOI
    const val = processDialData(version, data, spLayer, activeGroup, ecoregion.value, season, FishGroups, FishMeanSDs, 75, 90)
    return val
})


const barData = computed(() =>{
    const percHVHVals = [90] // values that are used to calculate the % high & very high abundance
    let barData = processStackedBarData(version, data, spLayer, activeGroup, FishGroups, AllCodes, barCategories, barSortOrder, percHVHVals)
    if (barData == "need data"){ 
        // this can happen if a group is selected then a share link is used.  When returning, not all
        // groups are necessarily in the processedData object, so need to fetch the cellData again
        getData(userPolygon.value.polyID, 1, true)
        barData = processStackedBarData(version, data, spLayer, activeGroup, FishGroups, AllCodes, barCategories, barSortOrder, percHVHVals)
    }
    return barData
})

const fishOverTime =  computed(() =>{
    const timeData = processSpTimeTable(fishTimeLayer, version, activeGroup, data, FishGroups, AllCodes)
    return timeData
})

const barSortOrder = ["High", "Medium", "Low", "Very Low", "No Data"]
const barCategories = {
    "-9" : "No Data",
    "0" : "Very Low", 
    "1" : "Low",
    "75" :"Medium",
    "90" :"High"
}



// if spLayer is a computed property, then the barGraphs computed property
// updates twice on season change.  Better for spLayer to be updated directly when season is
const spLayer = ref("FISH_HIGHBIO_ALL")
const seasonChange = () =>{
    // load the new fish data 
    logGAevent("fish_season", season.value.value, "")

    spLayer.value = "FISH_HIGHBIO_" + season.value.value
    loadDataByID(spLayer.value, version.value)
    // and return to density tab (so new click needed to load  time data)
    // this is needed because the dial stays
    fishTabs.value = 'density'
    clearMap();
}

const fishTimeLayer = computed(() =>{
    return "FISH_COMB_" + season.value.value 
})

const fishTabs = ref('density')
const season = ref({value: "ALL", label: "All Year"})
const seasons = ref([{value: "ALL", label: "All Year"},{value: "SPR", label: "Spring"}, {value: "FALL", label: "Fall"}])

const spGroupChoices = computed(() =>{
    const choices =[]
    for (const [key, value] of Object.entries(FishGroups)) {
        choices.push({value: key, label: spGroupPrettyNames[key]})
    }
    return choices
})

const activeSpCode =ref({value: "", label: ""})
const spChoices  = computed(() =>{
    const choices =[]
    FishGroups[activeGroup.value.value].forEach((sp) =>{
        choices.push({value: sp, label: AllCodes[sp]})
    })
    // console.log(choices)
    return choices
});

const activeGroup = computed({
    get: () => {
        const gr = activeSpGroups.value['fish']
        const grObj = arrayFindObjectByProp(spGroupChoices.value, "value", gr)
        return grObj
    },
    set: (value) => {
        setActiveSpGroups("fish", value.value)
        logGAevent("fish_group", value.value, "")
    }
});

const dialColors = {'color1' :'#F1FDFC', 'color2' : '#1D8177', 'color3' :'#02524a'}
const barColors ={
    "High" : "#830C5D",
    "Medium" : "#F16DC6",
    "Low" : "#EEB3DA",
    "Very Low"  : "#F7E8F2",
    "No Data" : "#a1a1a1"
}

const spGroupPrettyNames ={
  "all": "All Fish",
  "demersal": "Demersal fish",
  "forage": "Forage fish",
  "diadromous": "Diadromous fish",
  "nersgcnconservation": "High value for conservation by NE RGSCN",
  "climate": "Abundance vulnerable to climate change",
  "nefmc": "Multispecies managed by NEFMC",
  "mesh": "Small mesh species managed by NEFMC",
  "skates": "Skates managed by NEFMC",
  "mafmc": "With Fish Management Plans under MAFMC",
  "efh": "With EFH plans",
  "asmfc": "With Fish Management Plans under ASMFC"
}

const legendColorStopNames ={
    '-9' : "No Data",
    "0" : "Very Low",
    "1" : "Low",
    "75" : "Medium", 
    "90" : "High"
}

const tableCellColors ={
    "90" : "#830C5D",
    "75" : "#F16DC6",
    "1" : "#EEB3DA",
    "0"  : "#F7E8F2",
    "-9" : "#a1a1a1"
}
const columns: QTableColumn[] = [
    { name: 'name', required: true, label: 'Species', align: 'left',field: row => row.name, format: val => `${val}`, sortable: true, style: 'width:60px; max-width: 60px;'  },
    { name: 'd2010', align: 'center', label: 'Current', field: 'current', sortable: true, style: 'width: 45px; max-width: 45px;'  },
    { name: 'd2000', align: 'center', label: '2000s', field: 'd2000', sortable: true, style: 'width: 45px; max-width: 45px;'  },
    { name: 'd1990', align: 'center', label: '1990s', field: 'd1990', sortable: true, style: 'width: 45px; max-width: 45px;'  },
    { name: 'd1980', align: 'center', label: '1980s', field: 'd1980', sortable: true, style: 'width: 45px; max-width: 45px;'  },
    { name: 'd1970', align: 'center', label: '1970s', field: 'd1970', sortable: true, style: 'width: 45px; max-width: 45px;'  },
]

const fishTimeLegendTitles = computed(() =>{
    // used in the map legend-- needed so that year is updated
    // when you click on a table column
    const titles = {
        "d2010" : "Persistently High Biomass (Current)",
        "d2000" : "Persistently High Biomass (2000s)",
        "d1990": "Persistently High Biomass (1990s)",
        "d1980": "Persistently High Biomass (1980s)",
        "d1970": "Persistently High Biomass (1970s)",
    }
    return titles

})

const zDialConfig = computed(() =>{
    return {
        minVal: -2.5,   //dial min value
        maxVal: 2.5,    //dial max value
        majorTicks: 35, //this is the number of color gradations
        ticks: [-2, -1, 0, 1, 2],  //numberical label
        labels: ["Far Less", "Less", "Avg", "More", "Far More"],  //optional array of pretty names that will replace numerical.  Must be in same order
        labelSize: 10  //px size of the labels
    }
})
const barName = (i) =>{
    return "fishBar" + i
}

const processSpTimeTable = (fishTimeLayer, version, activeSpGroup, data, SpGroups, AllCodes) =>{
    // console.log(fishTimeLayer.value)
    if (
        !processedData.value[version.value] || 
        processedData.value[version.value][fishTimeLayer.value] === undefined || 
        processedData.value[version.value][fishTimeLayer.value]['decades']===undefined|| 
        processedData.value[version.value][fishTimeLayer.value]['decades'][activeSpGroup.value.value]===undefined
    ){  
        // console.log("calculating fish data over time")
        const cellData = data.value[fishTimeLayer.value];

        const fishDecadeData = []

        const grp = activeSpGroup.value.value;
        const spToShow = SpGroups[grp]

        spToShow.forEach((sp) =>{
            const current=[]
            const d2000=[]
            const d1990=[]
            const d1980=[]
            const d1970=[]
            cellData.forEach((cell) =>{
                // console.log(cell)
                if (cell[sp] != undefined && cell[sp] != " " && cell[sp] != ""){
                
                    // ninenineToNegNine() converts 99 to -9.  No Data is 99 in this layer
                    // but taking the max value, so need to make it < 0
                    current.push(ninenineToNegNine(parseInt(cell[sp].slice(12, 14))));
                    d2000.push(ninenineToNegNine(parseInt(cell[sp].slice(9, 11))));
                    d1990.push(ninenineToNegNine(parseInt(cell[sp].slice(6, 8))));
                    d1980.push(ninenineToNegNine(parseInt(cell[sp].slice(3, 5))));
                    d1970.push(ninenineToNegNine(parseInt(cell[sp].slice(0, 2))));
                }
                else{
                    // 99 is no data in this table
                    current.push(-9);
                    d2000.push(-9);
                    d1990.push(-9);
                    d1980.push(-9);
                    d1970.push(-9);
                }
            })

            let c = Math.max(...current)
            let d00 = Math.max(...d2000)
            let d90 = Math.max(...d1990)
            let d80 =Math.max(...d1980)
            let d70 =Math.max(...d1970)

            fishDecadeData.push({
                name : AllCodes[sp],
                spID: sp,
                current: c,
                d2000: d00,
                d1990: d90,
                d1980: d80,
                d1970: d70,
            })

            fishDecadeData.sort(function (a, b) {
            return (
                b["current"] - a["current"] ||
                b["d2000"] - a["d2000"] ||
                b["d1990"] - a["d1990"] ||
                b["d1980"] - a["d1980"] ||
                b["d1970"] - a["d1970"] ||
                b["name"] - a["name"]
            );
            });
        })
        // console.log(fishDecadeData);
        setProcessedData(version.value, fishTimeLayer.value, 'decades', activeSpGroup.value.value, fishDecadeData)
        return fishDecadeData
    }
    else{
        // console.log("loading saved processed decade results")
        const fishDecadeData = processedData.value[version.value][fishTimeLayer.value]['decades'][activeSpGroup.value.value]
        return fishDecadeData
    }
 }

const ninenineToNegNine = (v) =>{
    if (v == 99){return -9}
    else{return v}
}

const rowClick = (spID, sp) =>{
    let lyrID
    activeSpCode.value = spID;
    if (activeLayerID.value.includes("QUALITY")){
        lyrID = activeLayerID.value.replace("_QUALITY", "")
        setDataQuality(false)
        loadDataByID(lyrID, version.value)
    }
    else{lyrID = activeLayerID.value}
    styleMap(lyrID, spID, 'categorical', stops['spp_90max'], legendColorStopNames), 
    setLegend(sp + ' Persistent Biomass', stops['spp_90max'], legendColorStopNames)
}


const decade = ref({"value" : "d2010", "label" : "Current"})
const decades = [
    {"value" : "d2010", "label" : "Current"},
    {"value" : "d2000", "label" : "2000s"},
    {"value" : "d1990", "label" : "1990s"},
    {"value" : "d1980", "label" : "1980s"},
    {"value" : "d1970", "label" : "1970s"}
]

const spChange = (spID, sp) =>{
    console.log(spID, sp)
    tableCellClick(spID, sp)
}

const decadeChange = (e) =>{
    // console.log(e)
    decade.value = arrayFindObjectByProp(decades, "value", e.value)
    tableCellClick(activeSpCode.value.value, AllCodes[activeSpCode.value.value])
}

const tableClickEmitFunc = (e) =>{
    // console.log(e)
    const spID = e.sp;
    decade.value = arrayFindObjectByProp(decades, "value", e.decade)
    console.log(spID, AllCodes[spID])
    tableCellClick(spID, AllCodes[spID])

}

const tableCellClick = (spID, sp) =>{
    console.log(spID)
    
    if (typeof spID === 'object'){
        activeSpCode.value= spID
    }
    else{
        activeSpCode.value = {value: spID, label: sp};
    }

    logGAevent("fish_table_click", activeSpCode.value, "")

    const lyrID = `FISH_TIME_${season.value.value}_${spID}` //colObj.name;
    console.log(activeLayerID.value)
    console.log(lyrID)
    if (activeLayerID.value != lyrID){
        loadDataByID(lyrID, version)
    }
    let attr =  decade.value.value
    // console.log(attr)
    // console.log(lyrID)

    styleMap(lyrID, attr, 'categorical', stops['spp_90max'], legendColorStopNames) 
    setLegend(sp + " (" +decade.value.label+"): Estimated Density", stops['spp_90max'], legendColorStopNames)


}

const barChartTabTitle = computed(() =>{
    if (season.value.value == "ALL"){
        return "Annual Max. (2010 - 2019)"
    }
    else{
        return `${season.value.label} (2010 - 2019)`
    }
})

const decadeTabTitle= computed(() =>{
    if (season.value.value == "ALL"){
        return "Annual Max. By Decade"
    }
    else{
        return `${season.value.label} By Decade`
    }
})

const infoDialogs = ref({
  fishDecade: {
    pName: "Decade Data",
    model: false,
        text: "Please note..."
  },
  fishDiversity: {
    pName: "Fish Diversity",
    model: false,
    text: "Fish diversity values show the number of species that are both considered persistent (in the area for at least 6 out of the past 10 years) and have high abundance values (above the 90 percentile threshold - 10% of top values). Data sources include the NEFSC Bottom Trawl Survey from 2011 to 2020.  <div class='q-pt-sm'>The dial graphic displaying diversity relative to the ecoregion is only available for the 'All Fish' group.</div>"
  },
  fishAbundance: {
    pName: "Fish Abundance",
    model: false,
    text: "Abundance values are based on NEFSC Bottom Trawl Survey from 2011 to 2020. You can see other decades in the 'Over time' tab. Areas of 'high abundance' have values above the 90 percentile threshold (10% of top values). Threshold values are calculated by species across all seasons. Yearly values are maximum values across both seasons."
  },
  all: {
    pName: "All Fish",
    model: false,
    text: "The All Fish group includes all fish species for which data are available."
  },
  demersal: {
    pName: "Demersal Fish",
    model: false,
    text: "Demersal fish includes species that primarily live on or near the seafloor. This species group was created by a group of experts convened by the Regional Data Portals. It includes the following species: Acadian Redfish, American Plaice, Atlantic Cod, Atlantic Halibut, Barndoor Skate, Black Sea Bass, Clearnose Skate, Cunner, Fourspot Flounder, Goosefish, Haddock, Little Skate, Longhorn Sculpin, Ocean Pout, Offshore Hake, Pollock, Red Hake, Rosette Skate, Scup, Sea Raven, Silver Hake, Smooth Skate, Spotted Hake, Summer Flounder, Tautog, Thorny Skate, White Hake, Windowpane, Winter Flounder, Winter Skate, Witch Flounder, and Yellowtail Flounder. Note that there may be other demersal fish species that have no data available. "
  },
  forage: {
    pName: "Forage Fish",
    model: false,
    text: "Forage fish are fish species that are common prey items for other fish, marine mammals, or birds. This species group was created by a group of experts convened by the Regional Data Portals. These include the following species: Alewife, American Shad, Atlantic Herring, Atlantic Mackerel, Atlantic Menhaden, Bay Anchovy, Blueback Herring, Butterfish, Hickory Shad, Round Herring, Sand Lance, and Striped Anchovy. Note that there may be other forage  fish species that have no data available. "
  },
  diadromous: {
    pName: "Diadromous Fish",
    model: false,
    text: "Diadromous species are fish that spend part their life-cycle in fresh water (rivers, estuaries), and part in salt water. This species group was created by a group of experts convened by the Regional Data Portals. It includes Alewife, American Eel, American Shad, Atlantic Sturgeon, Blueback Herring, and Hickory Shad. Note that there may be other diadromous fish species that have no data available. "
  },
  nersgcnconservation: {
    pName: "High value for conservation by NE RGSCN",
    model: false,
    text: "This group includes fish species that are considered High or Very High value for conservation by the Northeast Fish & Wildlife Technical committee. This includes the following species: Barndoor skate, Smooth skate, Atlantic herring, Alewife, Blueback herring, American shad, Atlantic Cod, Winter Flounder, stripped bass, weakfish, Atlantic sturgeon, and American eel. Note that there may be other high priority species that have no data available within our region. "
  },
  climate: {
    pName: "Abundance vulnerable to climate change",
    model: false,
    text: "This group includes benthic fish species that are considered highly vulnerable to climate related changes in abundance. See Hare et al. (2016) for more information. It includes the following species: Alewife, American Eel, American Shad, Atlantic Halibut, Atlantic Sturgeon, Atlantic Wolffish, Black Sea Bass, Blueback Herring, Cusk, Ocean Pout, Sand Tiger, Striped Bass, Tautog, Thorny Skate, Tilefish, Winter Flounder, Witch Flounder"
  },
  nefmc: {
    pName: "Multispecies managed by NEFMC",
    model: false,
    text: "This group includes fish species under the Northeast Multispecies Fishery Management Plan (FMP) under the New England Fishery Management Council (NEFMC). It includes Acadian Redfish, American Plaice, Atlantic Cod, Atlantic Halibut, Haddock, Ocean Pout, Pollock, White Hake, Windowpane, Winter Flounder, Witch Flounder, Yellowtail Flounder."
  },
  mesh: {
    pName: "Small mesh species managed by NEFMC",
    model: false,
    text: "This group includes fish species under the Small-mesh Mutispecies Fishery Management Plan (FMP) under the New England Fishery Management Council (NEFMC). It includes Offshore Hake, Red Hake, Silver Hake."
  },
  skates: {
    pName: "Skates managed by NEFMC",
    model: false,
    text: "This group includes species of Skates that are managed by the New England Fishery Management Council (NEFMC). This includes the following species: Barndoor Skate, Clearnose Skate, Little Skate, Rosette Skate, Smooth Skate, Thorny Skate, Winter Skate."
  },
  mafmc: {
    pName: "With Fish Management Plans under MAFMC",
    model: false,
    text: "This group includes benthic fish species with Fish Management Plans (FMP) under the Mid-Atlantic Fishery Management Council (MAFMC). It includes the following species: Atlantic Mackerel, Black Sea Bass, Bluefish, Butterfish, Scup, Spiny Dogfish, Summer Flounder, Tilefish."
  },
  efh: {
    pName: "With EFH plans",
    model: false,
    text: "This group includes benthic species with Essential Fish Habitat (EFH) Plans. It includes the following species: Acadian Redfish, American Plaice, Atlantic Cod, Atlantic Halibut, Atlantic Herring, Atlantic Mackerel, Atlantic Wolffish, Barndoor Skate, Black Sea Bass, Bluefish, Butterfish, Clearnose Skate, Goosefish, Ocean Pout, Offshore Hake, Pollock, Red Hake, Rosette Skate, Scup, Silver Hake, Smooth Skate, Spiny Dogfish, Summer Flounder, Thorny Skate, Tilefish, White Hake, Windowpane, Winter Flounder, Winter Skate, Witch Flounder, Yellowtail Flounder."
  },
  asmfc: {
    pName: "With Fish Management Plans under ASMFC",
    model: false,
    text: "This group includes benthic species with Fish Management Plans (FMPs) under the Atlantic States Marine Fisheries Commission (ASMFC). It includes the following species: Alewife, American Eel, American Shad, Atlantic Croaker, Atlantic Herring, Atlantic Menhaden, Atlantic Sharpnose Shark, Atlantic Sturgeon, Black Sea Bass, Blueback Herring, Bluefish, Sand Tiger, Scup, Spiny Dogfish, Spot, Striped Bass, Summer Flounder, Tautog, Weakfish, Winter Flounder."
  },
  fishDialAll :{
    pName: "Relative Density Dials (All Year)",
    model: false,
    text: "These dials are based on diversity values for the area of study compared to the ecoregional averages. Diversity values are calculated by adding the number of species that have yearly abundance values beyond the 'Very high' threshold (90th percentile). The reference values for the ecoregions are the following (mean|st. deviation): Gulf of Maine (4.85|2.01); Virginian (3.84|1.7)."

  },
  fishDialSpr:{
    pName: "Relative Density Dials (Spring)",
    model: false,
    text: "These dials are based on diversity values for the area of study compared to the ecoregional averages. Diversity values are calculated by adding the number of species that have Spring abundance values beyond the 'Very high' threshold (90th percentile). The reference values for the ecoregions are the following (mean|st. deviation): Gulf of Maine (3.15|1.7); Virginian (2.05|1.55). "

  },
  fishDialFal:{
    pName: "Relative Density Dials (Fall)",
    model: false,
    text: "These dials are based on diversity values for the area of study compared to the ecoregional averages. Diversity values are calculated by adding the number of species that have Fall abundance values beyond the 'Very high' threshold (90th percentile). The reference values for the ecoregions are the following (mean|st. deviation): Gulf of Maine (3.72|2); Virginian ( 2.23|1.51). "

  },
  pHigh: {
    pName: "Percent High",
    model: false,
    text: "This value shows the percent of the area that is above the 'High' threshold (>90th percentile)"
  }
})

const dataConsiderations = ref(false)


const clearMap = () =>{
    clearMapStyle();
    activeSpCode.value = null;
    decade.value = null;
}

onMounted(() => {
    if (activeLayerID.value != spLayer.value){
        loadDataByID(spLayer.value, version)
    }
    // if coming from saved data, load the map style
    if (processedData.value && processedData.value['mapStyle']){
        activeSpCode.value.value = processedData.value['mapStyle']['attr'].replace("_S", "")
        activeSpCode.value.label = AllCodes[processedData.value['mapStyle']['attr'].replace("_S", "")]
    }
})


onUnmounted(() =>{
    clearMap();
    activeSpCode.value = null;
})
</script>
<style scoped>

.pointer{
    cursor: pointer;
}

.highlight{
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border: 1px solid #aeaeae;
    margin: 3px;
    border-radius: 3px;
    position: relative;
    z-index: 10;
    /* margin-right: 3px; */
    /* padding-bottom:0px; */
    min-height: 12px !important; 
}
.bar-row{
    max-height: 19px;
    /* overflow: hidden; */
}
.dial-container{
    max-width: 200px;
}
.bar-rows-container{
    padding: 5px;
    max-height: 250px;
    overflow: auto;
    outline: none; /* Remove default focus outline */
}
.bar-rows-container:focus {
  outline: 2px solid #24302b; /* Add custom focus outline */
}

.time-table-container{
    max-width: 400;
    /* overflow: hidden; */

}
.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.tab-container{
    border-radius: 3px;
    border: 1px solid #aeaeae;
}
.secondary-dropdown{
    border: 1px solid #1D8177;
    border-radius: 5px;
    min-height:70px;
    font-size: small;
}
.map-descr-row{
    background-color: #F1FDFC;
}
</style>